import { ModalComponent } from './modal.component'
export default ModalComponent
